import { NgModule } from '@angular/core';
import { ColumnComponent } from './column.component';
import { ColumnElementDirective } from './column-element.directive';

@NgModule({
    declarations: [ColumnComponent, ColumnElementDirective],
    exports: [ColumnComponent, ColumnElementDirective]
})
export class ColumnModule {}
